import { ReduxStore } from 'store/types';

function getAllThreadsErrorMessage(state: ReduxStore): string {
  return state.intervention.getAllThreads.config.errorMessage;
}

export default getAllThreadsErrorMessage;
